import { Locale } from "i18n/locale";

// Formats a monetary amount using the locale's conventions — comma decimal
// separator and space thousands grouping in French ("2 427,50"), dot decimal
// and NO grouping in English ("2427.50"). Used for the €-prefixed price figures
// on the listing cards and the booking price breakdown so amounts read
// correctly in each language instead of always using the English "." decimal.
export const formatAmount = (
  value: number | string,
  locale: Locale,
  fractionDigits = 2
): string => {
  const n = Number(value);
  return new Intl.NumberFormat(locale === "fr" ? "fr-FR" : "en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    // English drops the thousands separator by request — "17395.80", not
    // "17,395.80". French keeps its grouping, which uses a space and so never
    // reads as a decimal point ("17 395,80").
    useGrouping: locale === "fr",
  }).format(Number.isFinite(n) ? n : 0);
};
